export default {"src":"/_next/static/media/desmos-graphing.0ba9e765.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};